import { FormHelperText, Grid, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import TinyRichEditor from '../../../../../shared/components/TinyRichEditor'
import { InputCountry } from '../../../../../shared/components/inputs'
import { FormFieldProps } from '../../../models/novelties'
import LanguageMultiAutocomplete from '@/contexts/shared/components/inputs/LanguageMultiAutocomplete'
import RoleAutocomplete from '@/contexts/shared/components/inputs/RoleAutocomplete'
import StatusAutocomplete from '@/contexts/shared/components/inputs/StatusAutocomplete'
import VisibilityAutocomplete from '@/contexts/shared/components/inputs/VisibilityAutocomplete'
import { IRootState } from '@/redux/types'
import { useSelector } from 'react-redux'
import { IStatus, IVisibility } from '@/contexts/backoffice/courses/models/course'

interface GeneralTabProps extends FormFieldProps {
  STATUS: IStatus[]
  VISIBILITY: IVisibility[]
}

const NoveltyGeneralTab = ({ novelty, handleInputChange, STATUS, VISIBILITY }: GeneralTabProps) => {
  const { t } = useTranslation(['global'])

  const { errorForm, msgForm } = useSelector((state: IRootState) => state.validator)

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <InputCountry value={novelty.countries} handleInputChange={handleInputChange} />
        <FormHelperText error={errorForm.status}>{msgForm.status}</FormHelperText>
      </Grid>
      <Grid item xs={12} sm={4}>
        <LanguageMultiAutocomplete value={novelty.languages} handleInputChange={handleInputChange} />
      </Grid>
      <Grid item xs={12} sm={4}>
        <RoleAutocomplete value={novelty.role} handleInputChange={handleInputChange} />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <StatusAutocomplete value={novelty.status} handleInputChange={handleInputChange} options={STATUS} />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <VisibilityAutocomplete value={novelty.visibility} handleInputChange={handleInputChange} options={VISIBILITY} />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField label={t('author')} fullWidth disabled variant="filled" margin="normal" value={novelty.creator} onChange={() => {}} />
      </Grid>
      <Grid item xs={12}>
        <TinyRichEditor value={novelty.content} handleInputChange={handleInputChange} uploadURL="/novelties/upload" />
        <FormHelperText error={errorForm.content}>{msgForm.content}</FormHelperText>
      </Grid>
    </Grid>
  )
}

export default NoveltyGeneralTab
